import BaseService from "src/packages/BaseService";

export default class UserLessonService extends BaseService {
	static get className () {
		return "user";
	}
};
